import {I18n} from '@aws-amplify/core';
import {SimplePageHeader} from '@flexinet/ui-components';
import {useVerifiedPermissions} from "../../../../hooks/useVerifiedPermissions.ts";
import {rbacActions} from "../../../../config/rbac/actions.ts";
import {ReloadButton, AddButton, ViewProductsButton} from '../buttons';

const useTools = () => {
    const {allowedActions} = useVerifiedPermissions()

    const tools = [<ReloadButton key='reload'/>];

    if (allowedActions.includes(rbacActions.CreateSubscription)) {
        tools.push(<AddButton key='add'/>);
    }

    tools.push(<ViewProductsButton key='products'/>);

    return tools;
};

export const IndexPageHeader = () => {
    return (
        <SimplePageHeader
            title={I18n.get('Subscriptions')}
            tools={useTools()}
        />
    );
};


